import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getOptions, insertOptions, getOptionsByKey } from "../services/defaultValuesService";
import { setRsplListFromOptions } from "../config";
import i18n from "../i18n";
// Create the context
const OptionsContext = createContext();

// Custom hook to use the context
export const useOptions = () => useContext(OptionsContext);

const OptionsProvider = ({ children }) => {
	const navigate = useNavigate();
	const [options, setOptions] = useState(null);
	const [optionKeys, setOptionKeys] = useState(null);
	const [selectedTheme, setSelectedTheme] = useState(null);
	const [mfaDays, setMfaDays] = useState(null);
	const [mfaEnabled, setMfaEnabled] = useState(null);
	const [optionsLoading, setOptionsLoading] = useState(true);
	const supportedLanguages = ["en", "fr", "es", "de"];

	const convertBoolean = (value) => value === "true";

	const fetchOptions = async () => {
		console.log("Fetching Options");
		setOptionsLoading(true);
		try {
			const response = await getOptions();
			console.log("Options: ", response);

			if (response.status) {
			const opts = response.data.options; // this is an object
			setOptionKeys(opts); // save the whole object
			setOptions(response.data);
			setRsplListFromOptions(opts?.rsplList);

			// Access properties directly
			setMfaDays(parseInt(opts.mfaDays) || 15);
			setMfaEnabled(opts.mfaEnabled === "Enabled"); // boolean
			setSelectedTheme(opts.accentColor || opts.theme || "blue");
			}
		} catch (error) {
			console.log("Error fetching Options: ", error);
		} finally {
			setOptionsLoading(false);
		}
		};

	const setOption = async (options) => {
		try {
			const resp = await insertOptions({options});
			if (resp.status) {
				console.log("Option Updated", options);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getOption = async (option_key) => {
		try {
			const resp = await getOptionsByKey(option_key);
			if (resp.status) {
				console.log("Option Found", options);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		fetchOptions();
	}, []);

	useEffect(() => {
		if (!optionKeys) return;
		const translationEnabled = optionKeys.enableLanguageTranslation !== "false";
		const fallbackLanguage = supportedLanguages.includes(optionKeys.defaultLanguage)
			? optionKeys.defaultLanguage
			: "en";
		if (!translationEnabled) {
			if (i18n.language !== fallbackLanguage) {
				i18n.changeLanguage(fallbackLanguage);
			}
			return;
		}
		if (!supportedLanguages.includes(i18n.language)) {
			i18n.changeLanguage(fallbackLanguage);
		}
	}, [optionKeys]);

	return (
		<OptionsContext.Provider
			value={{
				options,
				optionKeys,
				optionsLoading,
				selectedTheme,
				mfaDays,
				mfaEnabled,
				setOption,
				getOption,
				fetchOptions
			}}>
			{children}
		</OptionsContext.Provider>
	);
};

export default OptionsProvider;
